import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4),
        backgroundColor: '#f8f9fb',
    },
    categoryTag: {
        backgroundColor: '#e6f0ff',
        color: '#0056d2',
        display: 'inline-block',
        padding: '4px 12px',
        borderRadius: 12,
        fontSize: 12,
        marginBottom: theme.spacing(1),
    },
    title: {
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
    },
    section: {
        marginTop: theme.spacing(3),
    },
    card: {
        padding: theme.spacing(2),
        borderRadius: 12,
        backgroundColor: '#fff',
        boxShadow: '0 0 4px rgba(0,0,0,0.1)',
    },
    tutorialVideo: {
        width: '100%',
        height: 320,
        backgroundColor: '#000',
        borderRadius: 15,
        marginTop: theme.spacing(2),
    },
    button: {
        marginTop: theme.spacing(2),
    },
    btnBack: {
        marginBottom: theme.spacing(2)
    },
    accessBox: {
        padding: theme.spacing(2),
        borderRadius: 12,
        backgroundColor: '#fff',
        boxShadow: '0 0 4px rgba(0,0,0,0.1)',
        height: 423,
        maxHeight: 423
    },
    link: {
        textDecoration: 'none',
    },
    dateCard: {
        marginLeft: '30%',
        marginBottom: '40px',
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10%',
            width: '88%',
        },
    },

    imageWrapper: {
        position: 'relative',
        width: '100%',
        height: 250,
        overflow: 'hidden',
        borderRadius: 12,
    },

    bannerImage: {
        width: '100%',
        height: '100%',
        filter: 'blur(10px) brightness(0.9)',
        objectFit: 'cover',
        display: 'block',
    },

    overlayContent: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        padding: 24,
        color: '#fff',
        background: 'linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.5), transparent)',
        borderBottomLeftRadius: 12,
        borderBottomRightRadius: 12,
    },
    categoryTag: {
        backgroundColor: '#1976d2',
        padding: '4px 12px',
        borderRadius: 16,
        display: 'inline-block',
        fontSize: 12,
        marginBottom: 14,
    },

    title: {
        fontWeight: 'bold',
        fontSize: 32,
        color: '#fff',
        marginBottom: 8,
    },

    subtitle: {
        fontWeight: 600,
        marginBottom: 16,
    },

    description: {
        fontSize: 16,
    },
    icon: {
        fontSize: 16,
        marginLeft: 12
    },
    customHtmlContainer: {
        padding: '0.5rem 1rem',
        fontSize: '14px !important',
        '& *': {
            fontSize: '14px !important',
            wordBreak: 'break-word',
        },
    },
}));